import { render, staticRenderFns } from "./Cabecalho.vue?vue&type=template&id=a1105746&"
import script from "./Cabecalho.vue?vue&type=script&lang=ts&"
export * from "./Cabecalho.vue?vue&type=script&lang=ts&"
import style0 from "./Cabecalho.vue?vue&type=style&index=0&id=a1105746&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports